import config from 'config/config';
import { calculateTokensWithDecimals } from 'shared/utils';
import { fetchQuota } from '../api';
import { calculateQuotaMinAmount } from './calculate-quota-min-amount';
import { getDecimalsForToken } from './get-decimals-for-token';

const FIAT_CURRENCY = 'USD';
const TOKEN_NAME = config.rampDefaultTokenName;

const MIN_TOKENS_AMOUNT = config.rampMinTokensAmount as number;

export const calculateSuggestedTokensAmount = async (originalAmount: number): Promise<string> => {
  const decimals = getDecimalsForToken(TOKEN_NAME);
  if (!decimals) {
    return '0';
  }

  const originalAmountWithDecimals = calculateTokensWithDecimals(originalAmount, decimals);

  if (MIN_TOKENS_AMOUNT && MIN_TOKENS_AMOUNT !== -1) {
    const minTokensWithDecimals = calculateTokensWithDecimals(MIN_TOKENS_AMOUNT, decimals);
    return Math.max(+minTokensWithDecimals, +originalAmountWithDecimals).toString();
  }

  const quota = await fetchQuota({
    fiatCurrency: FIAT_CURRENCY,
    tokenName: TOKEN_NAME,
    amount: originalAmount,
  });

  if (!quota) {
    return '0';
  }

  const minAmount = calculateQuotaMinAmount({
    fiatCurrency: FIAT_CURRENCY,
    tokenName: TOKEN_NAME,
    quota,
  });

  return Math.max(+minAmount, +originalAmountWithDecimals).toString();
};
